<template>
<div id="app">
  <div @click="noScale" class="no-scale-invisible-btn"></div>
  <router-view/>
</div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    this.scaleElement()
    window.onresize = () => {
      return (() => {
        this.scaleElement()
      })()
    }
  },
  data() {
    return {
      // isNoScale: false,
      clicks: 0
    }
  },
  created() {
    if (localStorage.getItem('isNoScale') === null) {
      localStorage.setItem('isNoScale', false)
    }
    if (JSON.parse(localStorage.getItem('isNoScale'))) {
      this.setNoScale()
    }
  },
  methods: {
    scaleElement() {
      if (!JSON.parse(localStorage.getItem('isNoScale'))) {
        let clientScale = document.documentElement.clientWidth / 3840
        document.getElementById('app').style.transform = `scale(${clientScale})`
        document.getElementById('app').style.transformOrigin = '0px 0px'
        document.body.style.width = document.documentElement.clientWidth + 'px'
        document.body.style.height = document.documentElement.clientHeight + 'px'
        if (document.getElementById('waveCanvas')) {
          document.getElementById('waveCanvas').style.width = '100vw'
        }
        if (document.getElementsByTagName('canvas')[0]) {
          document.getElementsByTagName('canvas')[0].style.height = 'calc(100% - 70%)'
          document.getElementsByTagName('canvas')[0].style.top = '100%'
        }
      }
    },
    setNoScale() {
      document.getElementById('app').style.transform = 'scale(1)'
      document.body.style.width = 'auto'
      document.body.style.height = 'auto'
      document.getElementById('waveCanvas').style.width = '3840px'
      document.getElementById('waveCanvas').style.height = '650px'
      document.getElementById('waveCanvas').style.top = '1836px'
    },
    noScale() {
      let isNoScale = JSON.parse(localStorage.getItem('isNoScale'))
      this.clicks += 1
      if (this.clicks === 5) {
        // this.isNoScale = !this.isNoScale
        localStorage.setItem('isNoScale', !isNoScale)
        this.clicks = 0
      }
      if (isNoScale) {
        this.setNoScale()
      } else {
        this.scaleElement()
      }
    }
  }
}
</script>

<style>
@import '/assets/style/font.css';

body {
  margin: 0;
  background: radial-gradient(#052e7e, #000323);
}

* {
  box-sizing: content-box;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  width: 3840px;
  height: 2160px;
}

#app .no-scale-invisible-btn {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue